const en = {
    // generic
    "close": "Close",
    "loading": "Loading...",

    // OPS page
    "public.ops.404.title": "Oops, something went wrong.",
    "public.ops.404.subtitle": "The page you are looking for no longer exists or could not be found.",

    "public.ops.country_disabled.title": "Country not available",
    "public.ops.country_disabled.subtitle": "We are sorry, but the program is not yet available in your country.",

    "public.ops.country_mismatch.title": "Country mismatch",
    "public.ops.country_mismatch.subtitle":
        "The country associated with your loyalty profile does not match the one linked to your B2C account. Please contact support for assistance.",

    "public.ops.generic.title": "An error occurred.",
    "public.ops.generic.subtitle": "Discover the conditions to participate in the GEWISS Passion loyalty program.",

    "public.ops.cta.label": "Go back",

    // welcome page
    "public.welcome.title": "Welcome to",
    "public.welcome.subtitle": "Install Gewiss products and collect points to access the rewards catalogue.",
    "public.welcome.cta.login": "Log in",
    "public.welcome.cta.signup": "Create an account",
    "public.welcome.cta.discover": "Learn more",
    "public.welcome.howto.title": "How does Gewiss Passion work?",
    "public.welcome.howto.lead": "Earning rewards is simple and quick.",
    "public.welcome.howto.step1.title": "1. Buy Gewiss products",
    "public.welcome.howto.step1.text": "Each purchase allows you to earn points and brings you closer to your favourite rewards.",
    "public.welcome.howto.step2.title": "2. Upload your invoice",
    "public.welcome.howto.step2.text":
        "Take a photo or upload the PDF: quick verification, points credited within a few days, and everything managed from the portal or web app.",
    "public.welcome.howto.step3.title": "3. Take on challenges",
    "public.welcome.howto.step3.text":
        "Answer surveys, watch training videos and test your knowledge with quizzes: every activity is another opportunity to earn points. Check the app regularly to stay updated on ongoing challenges.",
    "public.welcome.howto.step4.title": "4. Choose and request your reward",
    "public.welcome.howto.step4.text":
        "Reached your points goal? Browse the catalogue and request your reward whenever you want. It's your move.",

    // onboard
    "public.onboard.title": "Complete your loyalty profile",
    "public.onboard.subtitle": "Verify and complete your company information to finalize your registration",
    "public.onboard.form.submit.label": "Access the program",
    "public.onboard.form.submitting.label": "Access the program ...",

    "public.onboard.form.labels.vat": "VAT number *",
    "public.onboard.form.labels.business_name": "Business name *",
    "public.onboard.form.labels.business_email": "Email *",
    "public.onboard.form.descriptions.business_email":
        "Enter the company email address. We will use it to inform you about your membership in the program.",

    "public.onboard.form.labels.t_and_c": "",
    "public.onboard.form.labels.t_and_c_text":
        "I declare that I have read the <a href='https://www.gewiss.com/ww/en/about-gewiss/privacy-policy' target='_blank'>Privacy Policy</a> and accept the <a href='https://cdn.jnext-it.jakala.cloud/IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf' target='_blank'>program rules</a>.",
    "public.onboard.form.labels.agree": "Confirm",
    "public.onboard.form.labels.decline": "Do not agree",

    "public.onboard.form.validation.vat_required": "VAT number is required",
    "public.onboard.form.validation.vat_too_short": "Invalid VAT number",
    "public.onboard.form.validation.business_name_required": "Business name is required",
    "public.onboard.form.validation.business_name_too_short": "Business name is too short",
    "public.onboard.form.validation.business_email_required": "Email address is required",
    "public.onboard.form.validation.business_email_invalid": "Invalid email address",
    "public.onboard.form.validation.gdpr_required": "Terms and conditions are required",
    "public.onboard.form.validation.field_required": "This field is required",

    "public.onboard.form.feedback.vat_invalid.title": "Invalid VAT number.",
    "public.onboard.form.feedback.vat_invalid.message": "Invalid VAT number",
    "public.onboard.form.feedback.vat_invalid.label": "Close",
    "public.onboard.form.feedback.vat_already_used.message": "Registration cannot be completed. The VAT code entered is already registered.",

    "public.onboard.form.feedback.generic_error.title": "Failed.",
    "public.onboard.form.feedback.generic_error.label": "Close",
    "public.onboard.form.feedback.generic_error.message": "Please try again.",

    // footer
    "public.footer.text":
        "Registered office: Via Domenico Bosatelli 1 - 24069 CENATE SOTTO BG – Italy - Tax code and VAT number, registered with the Bergamo Chamber of Commerce under number: 00385040167 - Copyright ©2026 - Fully paid share capital €60,010,000.00. Company subject to the management and coordination of Polifin S.p.A.",
    "public.footer.links.rules.label": "Rules",
    "public.footer.links.rules.link": "IOJ3HsZEXv8qP/ptir6BAgERQzJ/assets/docs/fr/Rules.pdf",
    "public.footer.links.privacy.label": "Privacy Policy",
    "public.footer.links.privacy.link": "https://www.gewiss.com/ww/en/about-gewiss/privacy-policy",
    "public.footer.links.cookie.label": "Cookie Policy",

    "footer:unsubscribe_program": "Unsubscribe from the program",
    "unsubscribe:modal:title": "Confirm unsubscription",
    "unsubscribe:modal:text": "You are about to send a request to unsubscribe from the program.",
    "unsubscribe:modal:fineprint": "Your request will be processed within {{days}} business days.",
    "unsubscribe:modal:cta": "Confirm unsubscription",

    "unsubscribe:modal:loading:title": "Sending request",
    "unsubscribe:modal:loading:text": "We are sending your unsubscription request.",

    "unsubscribe:modal:success:title": "Request sent",
    "unsubscribe:modal:success:text": "Your unsubscription request has been sent successfully.",
    "unsubscribe:modal:success:label": "Close",

    "unsubscribe:modal:error:text": "An error occurred while sending your request. Please try again later.",

    "public.language.modal.title": "Choose language",
    "public.language.open_picker": "Open language picker",
    "public.language.current_prefix": "You are in",
    "public.language.change_country": "Change country"
};

export default en;